// extracted by mini-css-extract-plugin
export default {"tableRow":"TableRow_tableRow__vt8oJ","disabledHover":"TableRow_disabledHover__4bwQI"};